import { TmaisBannerData } from '@/features/tmaisBanners/types/tmaisBanner.type';
import { format, parseISO } from 'date-fns';
import { ArrowBigRight, UserRoundIcon } from 'lucide-react';
import ButtonLink from '@/common/components/ButtonLink';
import { ImageWithPlaceholder } from '@/common/components/ImageWithPlaceholder';
import { Link } from 'react-router-dom';
import Button from '@/common/components/Button';

export type TmaisBannerTableItem = {
  id: string;
  author_id?: string;
  author: JSX.Element | string;
  title: string;
  description: JSX.Element | string;
  active_at: string;
  expires_at: string;
  actions: JSX.Element | string;
};

const formatDate = (dateStr?: string | null) => {
  if (!dateStr) return '--';
  try {
    return format(parseISO(dateStr), "dd/MM/yyyy 'às' HH:mm");
  } catch {
    return '--';
  }
};

export class TmaisBannersTransformer {
  static showTransformer() {
    return (data: any): TmaisBannerData => {
      return {
        ...data,
        creator: data.creator || null,
        mobile_redirect_to: data.mobile_redirect_to || '',
        geo_geoables: data.geo_geoables || [],
      } as TmaisBannerData;
    };
  }

  static tableTransformer() {
    return (banners: TmaisBannerData[] = []): TmaisBannerTableItem[] =>
      banners.map((banner) => {
        const authorId = banner?.creator?.id;

        return {
          id: banner.id,
          author_id: authorId,

          author: authorId ? (
            <ButtonLink
              linkTo={`/users/${authorId}`}
              className="p-0 h-auto w-fit hover:no-underline"
              operationKlassToCheckPermission="Admin::Users::Show"
            >
              <div className="flex items-center gap-2">
                <ImageWithPlaceholder
                  url={(banner?.creator as any)?.profile_picture?.url}
                  alt={banner?.creator?.full_name || 'Autor'}
                  className="size-6 rounded-full shrink-0 overflow-hidden"
                  iconClassName="size-4"
                  placeholderIcon={UserRoundIcon}
                />
                <span className="text-white-800 font-medium whitespace-nowrap">
                  {banner?.creator?.full_name || 'Nome do usuário'}
                </span>
              </div>
            </ButtonLink>
          ) : (
            <div className="flex items-center gap-2">
              <ImageWithPlaceholder
                url={(banner?.creator as any)?.profile_picture?.url}
                alt={banner?.creator?.full_name || 'Autor'}
                className="size-6 rounded-full shrink-0 overflow-hidden"
                iconClassName="size-4"
                placeholderIcon={UserRoundIcon}
              />
              <span className="text-white-800 font-medium whitespace-nowrap">
                {banner?.creator?.full_name || 'Nome do usuário'}
              </span>
            </div>
          ),

          title: banner?.title || '--',
          description: (
            <span
              className="block max-w-[320px] truncate"
              title={banner?.description || ''}
            >
              {banner?.description || '--'}
            </span>
          ),
          active_at: formatDate(banner?.active_at),
          expires_at: formatDate(banner?.expires_at),

          actions: (
            <Link
              to={`/tmais-banners/${banner.id}`}
              className="w-full flex items-center justify-center"
              data-testid="show_button"
            >
              <Button
                variant="link-white"
                className="p-0 h-auto w-full rounded-sm flex items-center justify-center text-[#ffffffde] hover:text-[#ffffffde]"
                operationKlassToCheckPermission="Admin::Tmais::Banners::Show"
                disabledClassName="opacity-40 cursor-default"
                noPermissionText="Você não tem permissão"
              >
                <ArrowBigRight className="w-full" />
              </Button>
            </Link>
          ),
        };
      });
  }
}
